import { CrudRouter } from "javaee-fre";
const routers = [{
    path: 'home/admin/my/tenant/room/clazz', component: CrudRouter, meta: {
        desc: '<p class="sys-info">课堂学习可用于线下集中学习，可大屏视频播放、考勤（签到签退），可生成并导出培训档案。</p>',
        listActions: [{
            label: '查看平台授权课件', func() {
                this.$router.push(`/console/home/admin/my/tenant/room/clazz/available/courseware`);
            }
        }],
        listItemActions: [{
            label: '课件', icon: 'playlist_play', func(cfg) {
                this.$router.push(`/console/home/admin/my/tenant/room/clazz/courseware/${cfg.item.id}`, `课件设置 - ${cfg.item.name}`);
            }
        },
        {
            label: '视频', icon: 'movie', func(cfg) {
                this.$router.push(`/console/home/admin/my/tenant/room/clazz/media/${cfg.item.id}`, `视频设置 - ${cfg.item.name}`);
            }
        },
        {
            label: '课堂学习', icon: 'desktop_windows', func(cfg) {
                let self = this;
                window.open(`/oc/index.html?t=${self.$store.state.account.tenantId}&o=${self.$store.state.account.orgId}&c=${cfg.item.id}`)
            }
        },
        {
            label: '学员管理', icon: 'group', func(cfg) {
                let self = this;
                self.$router.push(`/console/home/admin/my/tenant/room/clazz/stu/${cfg.item.id}`, `学员管理 - ${cfg.item.name}`);
            }
        }],
        listItemFilter(i, acts) {
            if (i.finished || !i.enabled) {
                this.delAction(acts, 'icon', 'desktop_windows');
            }
            return acts;
        }
    },
    children: [
        {
            path: 'courseware/:_clazzId', component: CrudRouter, meta() {
                let self = this, acts = [{
                    label: '从平台授权课件添加', func() {
                        let self = this;
                        self.$dialog.crud('添加课件', {
                            url: '/home/admin/my/tenant/room/courseware',
                            selectStyle: 'multi',
                            listItemActions: [{
                                label: '预览', icon: 'visibility', func(cfg) {
                                    let self = this;
                                    self.$dialog.component(cfg.item.name || cfg.item.coursewareName, "courseware-view", {
                                        targetId: cfg.item.coursewareId,
                                        fullscreen: true
                                    });
                                }
                            }]
                        },
                            [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    let ids = Object.keys(sel);

                                    if (ids.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/my/tenant/room/clazz/courseware/add/${self.cfg.params._clazzId}/tc/${ids.join('_')}`).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.refresh();
                                                self.$status('添加成功', 'success');
                                            } else {
                                                self.$status(r.data.message || "操作失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                    }
                }, {
                    label: '从收藏夹添加课件', func() {
                        let self = this;
                        self.$dialog.crud(
                            "从收藏夹中选择课件",
                            {
                                url: "/home/my/favorite",
                                params: { _type: 2 },
                                editable: false, deleteable: false,
                                selectStyle: "multi",
                            },
                            [
                                {
                                    label: "确认",
                                    color: "primary",
                                    func(sel, arr) {
                                        if (!arr) {
                                            return;
                                        }
                                        let ids = arr.map((r) => r.targetId).join("_");
                                        self.$axios.get(`/home/admin/my/tenant/room/clazz/courseware/add/${self.cfg.params._clazzId}/self/${ids}`).then(r => {
                                            if (r.data) {
                                                if (r.data.status == "ok") {
                                                    self.refresh();
                                                    self.$status('添加成功', 'success');
                                                } else {
                                                    self.$status(r.data.message || "操作失败！", 'error');
                                                }
                                            }
                                        });
                                    },
                                },
                            ]
                        );
                    }
                }];
                if (self.$isInRole('ROLE_TENANT_SUPER') || self.$isInRole('ROLE_COURSE')) {
                    acts.push({
                        label: '从我的课件库添加', func() {
                            let self = this;
                            self.$dialog.crud(
                                "从我的课件库中选择",
                                {
                                    url: "/home/admin/c/courseware",
                                    editable: false, deleteable: false, createable: false,
                                    selectStyle: "multi",
                                },
                                [
                                    {
                                        label: "确认",
                                        color: "primary",
                                        func(sel, arr) {
                                            if (!arr) {
                                                return;
                                            }
                                            let ids = arr.map((r) => r.id).join("_");
                                            self.$axios.get(`/home/admin/my/tenant/room/clazz/courseware/add/${self.cfg.params._clazzId}/self/${ids}`).then(r => {
                                                if (r.data) {
                                                    if (r.data.status == "ok") {
                                                        self.refresh();
                                                        self.$status('添加成功', 'success');
                                                    } else {
                                                        self.$status(r.data.message || "操作失败！", 'error');
                                                    }
                                                }
                                            });
                                        },
                                    },
                                ]
                            );
                        }
                    })
                }
                return {
                    name: '课件设置', pagable: false, createable: false,
                    listActions: acts,
                    listItemActions: [{
                        label: '预览', icon: 'visibility', func(cfg) {
                            let self = this;
                            self.$dialog.component(cfg.item.name || cfg.item.coursewareName, "courseware-view", {
                                targetId: cfg.item.coursewareId,
                                fullscreen: true
                            });
                        }
                    }]
                };
            }
        },
        {
            path: 'media/:_clazzId', component: CrudRouter, meta() {
                let self = this, acts = [{
                    label: '从收藏夹添加视频', func() {
                        let self = this;
                        self.$dialog.crud(
                            "从收藏中选择课件",
                            {
                                url: "/home/my/favorite",
                                params: { _type: 1 },
                                editable: false, deleteable: false,
                                selectStyle: "multi",
                            },
                            [
                                {
                                    label: "确认",
                                    color: "primary",
                                    func(sel, arr) {
                                        if (!arr) {
                                            return;
                                        }
                                        let ids = arr.map((r) => r.targetId).join("_");
                                        self.$axios.get(`/home/admin/my/tenant/room/clazz/media/add/${self.cfg.params._clazzId}/${ids}`).then(r => {
                                            if (r.data) {
                                                if (r.data.status == "ok") {
                                                    self.refresh();
                                                    self.$status('添加成功', 'success');
                                                } else {
                                                    self.$status(r.data.message || "操作失败！", 'error');
                                                }
                                            }
                                        });
                                    },
                                },
                            ]
                        );
                    }
                }];
                let mRole = self.$isInRole('ROLE_TENANT_SUPER') || self.$isInRole('ROLE_MEDIA');
                if (mRole) {
                    acts.push({
                        label: '从我的视频库添加', func() {
                            let self = this;
                            self.$dialog.crud(
                                "从我的视频库中选择",
                                {
                                    url: "/home/admin/c/media",
                                    editable: false, deleteable: false, createable: false,
                                    selectStyle: "multi",
                                },
                                [
                                    {
                                        label: "确认",
                                        color: "primary",
                                        func(sel, arr) {
                                            if (!arr) {
                                                return;
                                            }
                                            let ids = arr.map((r) => r.id).join("_");
                                            self.$axios.get(`/home/admin/my/tenant/room/clazz/media/add/${self.cfg.params._clazzId}/${ids}`).then(r => {
                                                if (r.data) {
                                                    if (r.data.status == "ok") {
                                                        self.refresh();
                                                        self.$status('添加成功', 'success');
                                                    } else {
                                                        self.$status(r.data.message || "操作失败！", 'error');
                                                    }
                                                }
                                            });
                                        },
                                    },
                                ]
                            );
                        }
                    })
                }
                return {
                    name: '视频设置', pageable: false, createable: false,
                    desc: mRole ? '<p class="sys-info">要自行上传视频，请单击左边菜单<b>自建资源-视频管理</b>。</p>' : null,
                    listActions: acts,
                    listItemActions: [{
                        label: '播放视频', icon: 'play_circle_outline', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/my/media/cc/url/${cfg.item.mediaId}`).then(r => {
                                if (r.data && r.data.status == 'ok' && r.data.message) {
                                    self.$dialog.component(cfg.item.name || cfg.item.mediaName, 'cc-video-viewer', { movieUrl: r.data.message });
                                }
                            });
                        }
                    }]
                }
            }
        },
        {
            path: 'stu/:_clazzId', component: CrudRouter, meta: {
                name: '学员管理',
                listActions: [
                    {
                        label: '导出报表', func() {
                            let self = this;
                            window.open(`${self.$const.baseUrl}/home/admin/my/tenant/room/clazz/stu/export/report/form/html?_clazzId=${self.cfg.params._clazzId}`);
                        }
                    }
                ]
            }
        },
        {
            path: 'available/courseware', component: CrudRouter, meta: {
                name: '平台授权课件',
                url: '/home/admin/my/tenant/room/courseware',
                desc: '<p class="sys-info">以下为平台授权可线下大屏幕播放的课件，如有其他需求，请联系为您提供服务的服务商，我们会尽最大努力给企业提供帮助。</p>',
                listItemActions: [{
                    label: '预览', icon: 'visibility', func(cfg) {
                        let self = this;
                        self.$dialog.component(cfg.item.name || cfg.item.coursewareName, "courseware-view", {
                            targetId: cfg.item.coursewareId,
                            fullscreen: true
                        });
                    }
                }]
            }
        }
    ]
}];
export default {
    routers: routers
}